import useRequest from "~/composables/use-request";

const NotificationsAPI = {
  load(options: IRequestNotificationsParams): Promise<IPaginatedResponse<NotificationItem[]>> {
    const { request } = useRequest();
    return request.get<IPaginatedResponse<NotificationItem[]>>("/api/notification/list", { query: options });
  },

  loadUnreadCount(): Promise<number> {
    const { request } = useRequest();

    const options: IRequestNotificationsParams = {
      page: 0,
      size: 1,
      count: true,
      read: false,
    };

    return request
      .get<IPaginatedResponse<NotificationItem[]>>("/api/notification/list", { query: options })
      .then(response => response.content.totalCount ?? 0);
  },

  markAsRead(id: string): Promise<void> {
    const { request } = useRequest();
    return request.post("/api/notification/read", { body: { ids: [id] } });
  },

  markAllAsRead(): Promise<void> {
    const { request } = useRequest();
    return request.post("/api/notification/read", { body: { readAll: true } });
  },
  clearAll(): Promise<void> {
    const { request } = useRequest();
    return request.post("/api/notification/remove", { body: { deleteAll: true } });
  },
};

export default NotificationsAPI;
